import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppFilter } from '../../../../models/app-filter.model';
import { CancelaVotoAssembleia } from '../../../../models/assembleia/cancelaVotoAssembleia.model';
import { AbVoto } from 'app/abstract/full-pages/assembleia/voto.abstract';

@Injectable({ providedIn: 'root' })
export class VotoService extends AbVoto {
  prefixo = 'votos/';

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  public registrarVoto(itemId: number, opVotoId: number) {
    return this.save(`${this.prefixo}votar/${itemId}/${opVotoId}`, { id: null });
  }

  public getVotoRealizadoByItem(itemId: number) {
    return this.get(`${this.prefixo}voto_realizado/${itemId}`);
  }

  public validarExibirCancelarOuFinalizarVotacao(assembleiaId: number) {
    return this.get(`${this.prefixo}itens_votados/assembleia/${assembleiaId}`);
  }

  public finalizarVotacao(assembleiaId: number, tipoVoto: string) {
    return this.post(`${this.prefixo}assembleia/${assembleiaId}/finalizarVotos`, {
      tipoVoto: tipoVoto
    })
  }

  public findAllByFilter(filter: AppFilter) {
    return this.get(`${this.prefixo}filter/${filter.encode()}`);
  }

  public verificarSeOUsuarioPodeFinalizarVotos(assembleiaId: number) {
    return this.get(`${this.prefixo}verificarFinalizacao/${assembleiaId}`)
  }

  public resultadosAssembleiaVotos(assembleiaId: number) {
    return this.get(`${this.prefixo}resultados/assembleia/${assembleiaId}`);
  }

  public cancelarVoto(cancelaVotoAssembleia: CancelaVotoAssembleia) {
    return this.patch(`${this.prefixo}cancelarVoto`, { ...cancelaVotoAssembleia });
  }

  getRelatorio(assembleiaId: number) {
    return this.get(`${this.prefixo}relatorio/gerar/${assembleiaId}`);
  }
}